var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","dark":"","color":"secondary","clipped-left":"","height":"56"}},[(_vm.showMenu)?_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleSidebar}}):_vm._e(),_c('RaftLogo'),_c('v-spacer'),_c('v-row',{attrs:{"justify":"end"}},[_c('GamayunButton'),_c('UserMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }